export default "__VITE_ASSET__9717a36f__"